import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../../api-client';
import { LeaderboardEntry } from '../../models/leaderboard-entry';

@Injectable({ providedIn: 'root' })
export class LeaderboardService {
    constructor(private readonly httpClient: HttpClient, private readonly configuration: Configuration) { }

    getLeaderboard(options: { tournamentId?: string; roundId?: number }): Observable<LeaderboardEntry[]> {
        const url = `${this.configuration.basePath ?? ''}/leaderboards`;

        let params = new HttpParams();
        if (options.tournamentId) {
            params = params.set('tournamentId', options.tournamentId);
        }
        if (options.roundId !== undefined && options.roundId !== null) {
            params = params.set('roundId', options.roundId.toString());
        }

        let headers = new HttpHeaders();
        const accessToken = this.resolveAccessToken();
        if (accessToken) {
            headers = headers.set('Authorization', `Bearer ${accessToken}`);
        }

        return this.httpClient.get<LeaderboardEntry[]>(url, {
            params,
            headers,
            withCredentials: this.configuration.withCredentials
        });
    }

    private resolveAccessToken(): string | null {
        if (!this.configuration.accessToken) {
            return null;
        }

        const token = this.configuration.accessToken;
        return typeof token === 'function' ? token() : token;
    }
}
